import { render, staticRenderFns } from "./ReportsPage.vue?vue&type=template&id=04e57aed&scoped=true&"
import script from "./ReportsPage.vue?vue&type=script&lang=ts&"
export * from "./ReportsPage.vue?vue&type=script&lang=ts&"
import style0 from "./ReportsPage.vue?vue&type=style&index=0&id=04e57aed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e57aed",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VRow})
